import request from './request';

const queueService = {
    queueItems: (show, search, page, pageSize) => {
        return request({
            method: "get",
            url: "/queue/",
            params: {
                show,
                search,
                page,
                pageSize
            }
        });
    },
    history: (id, show) => {
        return request({
            method: "get",
            url: `/queue/${show}/${id}/history`
        });
    },
    requeue: (id, showName) => {
        let urlParts = ['/queue']

        if (showName !== undefined)
            urlParts.push(showName);

        urlParts = urlParts.concat([
            id,
            "requeue"
        ]);

        return request({
            method: "post",
            url: urlParts.join('/')
        })
    }
};

export default queueService;